import * as React from 'react';
import { LinkProps } from 'react-router-dom';

import { ChevronRight } from 'react-feather';
import { InternalLink } from './InternalLink';

export const SettingLink: React.FC<LinkProps> = ({
  children,
  className = '',
  ...linkProps
}) => {
  return (
    <InternalLink
      {...linkProps}
      className={`flex justify-between text-grey-700 hover:text-grey-900 ${className}`}
    >
      {children}
      <ChevronRight className="self-center flex-shrink-0 ml-2 text-grey-600" />
    </InternalLink>
  );
};
